import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper, { Navigation } from 'swiper';

const ArticleRecipes = () => {
    const sections = document.querySelectorAll('.recipe-article');

    Swiper.use([Navigation]);

    for (const section of sections) {
        const images = section.querySelector('[data-recipe-images]')
        const imagesSwiperEl = images.querySelector('.swiper')
        const topSection = section.querySelector('[data-intro-row]')
        const top = section.querySelector('[data-recipe-images-top]')
        const bottom = section.querySelector('[data-recipe-images-bottom]')

        /* Sticky image effect */
        const bgToTop = () => {
            if (window.innerWidth < 992) return; 
            top.append(images);
        }
        const bgToBottom = () => {
            if (window.innerWidth < 992) return; 
            bottom.prepend(images);
        }

        gsap.to(imagesSwiperEl, {
            scrollTrigger: {
                trigger: topSection,
                start: "50% top",
                end: "bottom top",
                scrub: true,
                onLeave: () => bgToBottom(),
                onEnterBack: () => bgToTop(),
            },
            opacity: .15
        })

        /* Images Swiper */
        const imagesSwiperMobileButtonHolder = section.querySelector('.recipe-images-swiper-mobile-button-holder')
        const imagesSwiperDesktopButtonHolder = section.querySelector('.recipe-images-swiper-desktop-button-holder')
        const imagesSwiperNext = section.querySelector('.recipe-images-swiper-button-next')
        const imagesSwiperPrev = section.querySelector('.recipe-images-swiper-button-prev')
        const imagesSwiper = new Swiper(imagesSwiperEl, {
            slidesPerView: 1,
            watchOverflow: true,
            spaceBetween: 0,
            navigation: {
                nextEl: imagesSwiperNext,
                prevEl: imagesSwiperPrev,
            },
        })
        const moveSwiperButtons = () => {
            if (window.innerWidth < 992) {
                imagesSwiperMobileButtonHolder.append(imagesSwiperPrev)
                imagesSwiperMobileButtonHolder.append(imagesSwiperNext)
            } else {
                imagesSwiperDesktopButtonHolder.append(imagesSwiperPrev)
                imagesSwiperDesktopButtonHolder.append(imagesSwiperNext)
            }
        }
        moveSwiperButtons();

        let lastWidth = window.innerWidth;
        window.addEventListener('resize', () => {
            if (lastWidth === window.innerWidth) return;
            if (lastWidth < 992 && window.innerWidth < 992) return;
            if (lastWidth >= 992 && window.innerWidth >= 992) return;

            moveSwiperButtons();

            if (window.innerWidth < 992) {
                top.append(images);
            } else {
                if (topSection.offsetTop < window.scrollY) {
                    bottom.prepend(images);
                } else {
                    top.append(images);
                }
            }

            ScrollTrigger.refresh();

            lastWidth = window.innerWidth;
        })

        /* Featured products swiper */
        const featuredProductsSwiperEl = section.querySelector('.featured-products-swiper')
        if (featuredProductsSwiperEl) {
            const featuredProductsSwiper = new Swiper(featuredProductsSwiperEl, {
                slidesPerView: 1,
                spaceBetween: 16,
                watchOverflow: true,
                navigation: {
                    nextEl: section.querySelector('.featured-products-swiper-button-next'),
                    prevEl: section.querySelector('.featured-products-swiper-button-prev'),
                },
            })
        }

        /* Anchor buttons */
        const directionsAnchor = section.querySelector('#directions')
        const ingredientsButton = section.querySelector('.anchor-buttons [href="#ingredients"]')
        const directionsButton = section.querySelector('.anchor-buttons [href="#directions"]')
        window.addEventListener('scroll', () => {
            if (window.scrollY - window.innerHeight < directionsAnchor.offsetTop) {
                ingredientsButton.classList.add('active')
                directionsButton.classList.remove('active')
            } else {
                ingredientsButton.classList.remove('active')
                directionsButton.classList.add('active')
            }
        })
    }
}

export default ArticleRecipes;